export const NOTIFY_SUCCESS = "NOTIFY_SUCCESS"
export const NOTIFY_ERROR = "NOTIFY_ERROR"
export const NOTIFY_OFFLINE_MODE = "NOTIFY_OFFLINE_MODE"
